import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import {
  AppBar,
  Box,
  Button,
  Card,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  get_user_details,
  getAdminPrescriptionlist,
  getDoctorsPrescriptionlist,
  getPrescriptionID,
  getReviewPrescriptionForAdmin,
  getUserPrescriptionCount,
} from "../api/api";
import imgUrl from "../assets/images/imgUrl";
import darkRoomNotificationSound from "../assets/images/sounds/dark_room_notification.mp3"; // replace with your actual sound file
import BasicDateRangePicker from "../components/CalendarComp";
import MainLoader from "../components/MainLoader";
import SidebarComp from "../components/Sidebar";
import paginationFactory from "react-bootstrap-table2-paginator";

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const audio = new Audio(darkRoomNotificationSound);

const AllPrescribedData = () => {
  const userInfo =
    sessionStorage.getItem("loggedInUserData") &&
    JSON.parse(sessionStorage.getItem("loggedInUserData"));
  const loggedInDoctorInfo = userInfo && userInfo;

  const playMusic = () => {
    audio.play().catch((err) => console.log("Audio play failed:", err));
  };

  // console.log(loggedInDoctorInfo?.role, "::ROle>>");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [clientStatus, setClientStatus] = useState(null); // "valid", "invalid", or null
  const [showInvalidDropdown, setShowInvalidDropdown] = useState(false);
  const [selectedInvalidValue, setSelectedInvalidValue] = useState(
    "Invalid or unverifiable medical documentation"
  );
  const [userAllInfo, setUserAllInfo] = useState("");
  const [allPrescriptionIds, setAllPrescriptionIds] = useState("");
  const [userReportData, setUserReportData] = useState("");
  const [prescriptionCount, setPrescriptionCount] = useState("");
  const [noDataErrMessage, setNoDataErrMessage] = useState("");
  const [isUserIdle, setIsUserIdle] = useState(false);
  // const open = Boolean(anchorEl);
  let idleTimeout;

  const prevPendingCountRef = useRef(null);
  const firstCallRef = useRef(true);

  // State for managing dropdown open/close
  const [selectedValue, setSelectedValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const countdownIntervalRef = useRef(null);
  const isCancelledByUserRef = useRef(false);

  const [searchText, setSearchText] = useState("");
  const [prescribedInfoList, setPrescribedInfoList] = useState([]);

  const [selectedRange, setSelectedRange] = useState([null, null]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(5);

  let prescribedListColumn = [];
  let prescribedListColumnKeys = new Set();
  const [dropdownValue, setDropdownValue] = useState("");
  const [filteredPrescribedList, setFilteredPrescribedList] = useState([]);

  useEffect(() => {
    if (prescribedInfoList && prescribedInfoList.length > 0) {
      const filteredList = prescribedInfoList.filter((lab) =>
        Object.values(lab).some((val) =>
          String(val).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      // Set the filtered list in state
      setFilteredPrescribedList(filteredList);
    }
  }, [prescribedInfoList, searchText]);

  const generateSizePerPageList = (sizePerPage, totalItems) => {
    const list = [];
    let multiple = sizePerPage;

    while (multiple < totalItems) {
      list.push({ text: multiple.toString(), value: multiple });
      multiple += sizePerPage;
    }
    list.push({ text: "All", value: totalItems });

    return list;
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: sizePerPage,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: generateSizePerPageList(
      sizePerPage,
      prescribedInfoList.length
    ),
    onPageChange: function (page, sizePerPage) {
      setPageNumber(page - 1);
      setPageSize(pageSize); // corrected variable from pageSize to sizePerPage
    },
    onSizePerPageChange: function (page, sizePerPage) {
      // Optional: handle size per page change
    },
  });

  //   const pagination = paginationFactory({
  //     page: 1,
  //     sizePerPage: sizePerPage,
  //     lastPageText: ">>",
  //     firstPageText: "<<",
  //     nextPageText: ">",
  //     prePageText: "<",
  //     showTotal: true,
  //     alwaysShowAllBtns: true,
  //     sizePerPageList: [
  //       {
  //         text: "5",
  //         value: 5,
  //       },
  //       {
  //         text: "10",
  //         value: 10,
  //       },
  //       {
  //         text: "15",
  //         value: 15,
  //       },
  //       {
  //         text: "20",
  //         value: 20,
  //       },
  //       {
  //         text: "All",
  //         value: prescribedInfoList.length,
  //       },
  //     ],
  //     onPageChange: function (page, sizePerPage) {
  //       setPageNumber(page - 1);
  //       setPageSize(pageSize);
  //     },
  //     onSizePerPageChange: function (page, sizePerPage) {
  //       // console.log(">>>page>>sizePerPage", page, sizePerPage);
  //     },
  //   });

  const handleSelectFilter = (event) => {
    const selectedValue = event.target.value; // "Prescribed" | "Proscribed"
    setDropdownValue(selectedValue);

    const filteredList = prescribedInfoList.filter(
      (item) => item.status == selectedValue // compare string ↔︎ string
    );

    setFilteredPrescribedList(filteredList);
  };

  const startCountdown = () => {
    clearInterval(countdownIntervalRef.current); // Clear existing timer
    isCancelledByUserRef.current = false;
    setSecondsRemaining(119); // Start from 1:59 for accurate countdown

    countdownIntervalRef.current = setInterval(() => {
      setSecondsRemaining((prevSeconds) => {
        if (prevSeconds <= 0) {
          clearInterval(countdownIntervalRef.current);
          if (!isCancelledByUserRef.current) {
            executeLogout();
          }
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  const resetIdleTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(() => {
      setIsUserIdle(true);
      startCountdown();
    }, 600000); // 5 minutes 5 * 60 * 1000-->600000
  };

  const handleUserActivity = () => {
    if (isUserIdle) {
      setIsUserIdle(false);
    }
    resetIdleTimer();
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];
    for (let event of events) {
      window.addEventListener(event, handleUserActivity);
    }
    resetIdleTimer();
    return () => {
      for (let event of events) {
        window.removeEventListener(event, handleUserActivity);
      }
      clearTimeout(idleTimeout);
    };
  }, []);

  // Handle menu open
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  // Handle menu close
  const handleMenuClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login-page");
  };
  // Handle select change
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  let bmiValue =
    (userAllInfo?.weight * 10000) / (userAllInfo?.height * userAllInfo?.height);
  let finalBmiValue = bmiValue.toFixed(2);

  useEffect(() => {
    handleGetPrescribedList();
  }, [endDate, pageSize, pageNumber]);

  useEffect(() => {
    handleGetPrescriptionID();
    handleUserPrescriptionCount();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      handleUserPrescriptionCount();
    }, 30000); // 30000ms = 30s
    return () => clearInterval(interval);
  }, []);

  const getUserDetails = async (userId) => {
    let reqBody = {
      // user_id: 141,
      user_id: userId,
    };
    setLoading(true);
    try {
      const response = await axios.post(get_user_details, reqBody);
      setLoading(false);
      if (response.status == 200) {
        setUserAllInfo(response.data);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleGetPrescriptionID = async () => {
    let reqBody = {
      doctor_id: loggedInDoctorInfo && loggedInDoctorInfo?.doctor_id,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        loggedInDoctorInfo?.role == "admin"
          ? getReviewPrescriptionForAdmin
          : getPrescriptionID,
        reqBody
      );
      setLoading(false);
      if (response.status == 200) {
        handleUserPrescriptionCount();
        setAllPrescriptionIds(response?.data);
        getValidationReviewData(response?.data?.analysis_id);
        getUserDetails(response?.data?.user_id);
        if (response.data.error) {
          setNoDataErrMessage(response.data.error);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getValidationReviewData = async (analysisId) => {
    let reqBody = {
      validation_level: 1,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `https://aloxa.ai/flaskservice/api/hair-analysis/${analysisId}/validation-review`,
        reqBody
      );
      setLoading(false);
      if (response.status == 200) {
        setUserReportData(response?.data);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const executeLogout = () => {
    toast.success("You have been logged out successfully.");
    localStorage.clear();
    sessionStorage.clear();
    setIsUserIdle(false);
    sessionStorage.removeItem("userLoggedIn");
    sessionStorage.removeItem("loggedInMobileNumber");
    navigate("/login-page", { replace: true });
    window.location.reload();
  };

  const handleCancelClick = () => {
    isCancelledByUserRef.current = true;
    clearInterval(countdownIntervalRef.current);
    setIsUserIdle(false);
  };

  const handleLogoutClick = () => {
    clearInterval(countdownIntervalRef.current);
    executeLogout();
  };

  const handleUserPrescriptionCount = async () => {
    const reqBody = {
      doctor_id: loggedInDoctorInfo?.doctor_id,
      role: loggedInDoctorInfo?.role,
    };

    try {
      const response = await axios.post(getUserPrescriptionCount, reqBody);
      if (response.status === 200) {
        const newPendingCases = response.data?.pending_cases;

        if (firstCallRef.current) {
          // Skip audio on first API call
          firstCallRef.current = false;
        } else {
          const prevPendingCases = prevPendingCountRef.current;

          // Play sound only if new value > previous
          if (newPendingCases > prevPendingCases) {
            playMusic();
            toast.success("New report generated. Please click on sync.");
          }
        }

        // Update current state and ref
        prevPendingCountRef.current = newPendingCases;
        setPrescriptionCount(response.data);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleReloadData = () => {
    handleGetPrescriptionID();
  };

  let medicationStatus =
    userAllInfo &&
    userAllInfo?.medications &&
    Object.keys(userAllInfo?.medications);

  // console.log(medicationStatus[0], "::>medicationStatus>>");
  const formatSecondsToTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  let transformedData =
    prescribedInfoList.length > 0 &&
    prescribedInfoList.forEach((item) => {
      const entries = Object.entries(item);
      entries.forEach(([key, value]) => {
        if (!prescribedListColumnKeys.has(key)) {
          //   let column = { dataField: key, text: key, sort: true };
          let column = {
            dataField: key,
            text: key
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase()), // Make key human-readable
            sort: true,
            formatter: (cell, row) => {
              if (cell === null || cell === undefined) return "-";
              // If value is object like { No: "No" }
              if (typeof cell === "object" && !Array.isArray(cell)) {
                return Object.values(cell).join(", ");
              }

              return String(cell);
            },
          };
          if (key == "first_name") {
            column.text = "Name of Patient";
            column.formatter = (cell, row) => {
              return (
                <p>
                  {row?.first_name} {row?.last_name}
                </p>
              );
            };
          }
          if (key === "prescription_slip_id") {
            column.text = "Id";
            column.formatter = (cell, row) => {
              return <p>{row?.prescription_slip_id}</p>;
            };
          }
          if (key == "prescription_date") {
            column.text = "Date of Prescription";
            column.formatter = (cell, row) => {
              return <p>{row?.prescription_date}</p>;
            };
          }
          if (key == "prescribed_medicine") {
            column.text = "Prescribed Medicine";
            column.formatter = (cell, row) => {
              return <p>{row?.prescribed_medicine || "NA"}</p>;
            };
          }
          if (key == "status") {
            column.text = "Status";
            column.formatter = (cell, row) => {
              return <p className="prescribedStatus">{row?.status}</p>;
            };
          }
          if (key === "last_name") {
            column.hidden = true;
          }
          if (key === "user_prescription") {
            column.hidden = true;
          }
          if (key === "compounder_prescription") {
            column.hidden = true;
          }
          if (key === "admin_comment") {
            column.hidden = true;
          }
          if (key === "age") {
            column.hidden = true;
          }
          if (key === "allergies") {
            column.hidden = true;
          }
          if (key === "date_of_birth") {
            column.hidden = true;
          }
          if (key === "document_issue_country") {
            column.hidden = true;
          }
          if (key === "document_number") {
            column.hidden = true;
          }
          if (key === "email") {
            column.hidden = true;
          }
          if (key === "document_type") {
            column.hidden = true;
          }
          if (key === "gender") {
            column.hidden = true;
          }
          if (key === "hair_loss_duration") {
            column.hidden = true;
          }
          if (key === "hair_loss_treatment") {
            column.hidden = true;
          }
          if (key === "height") {
            column.hidden = true;
          }
          if (key === "medical_history") {
            column.hidden = true;
          }
          if (key === "medications") {
            column.hidden = true;
          }
          if (key === "phone_number") {
            column.hidden = true;
          }
          if (key === "document_type") {
            column.hidden = true;
          }
          if (key === "prescription_comment") {
            column.hidden = true;
          }
          //   if (key === "prescription_slip_id") {
          //     column.hidden = true;
          //   }
          if (key === "prescription_validation") {
            column.hidden = true;
          }
          if (key === "psychological_state") {
            column.hidden = true;
          }
          if (key === "scalp_conditions") {
            column.hidden = true;
          }
          if (key === "user_id") {
            column.hidden = true;
          }
          if (key === "user_prescription") {
            column.hidden = true;
          }
          if (key === "weight") {
            column.hidden = true;
          }
          prescribedListColumn.push(column);
          prescribedListColumnKeys.add(key);
        }
      });
    });

  const handleGetPrescribedList = async () => {
    const reqBody = {
      doctor_id: loggedInDoctorInfo?.doctor_id,
      start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      end_date: endDate ? endDate.format("YYYY-MM-DD") : "",
      limit: pageSize,
      offset: pageNumber,
      //   start_date: "2025-06-03",
      //   end_date: "2025-06-11",
    };
    setLoading(true);

    try {
      const response = await axios.post(
        loggedInDoctorInfo?.role == "admin"
          ? getAdminPrescriptionlist
          : getDoctorsPrescriptionlist,
        reqBody
      );
      setLoading(false);
      if (response.status === 200) {
        setPrescribedInfoList(response?.data);
      }
    } catch (error) {
      setLoading(false);

      console.error("API Error:", error);
    }
  };

  //   const filteredPrescribedList =
  //     prescribedInfoList &&
  //     prescribedInfoList.filter((lab) =>
  //       Object.values(lab).some((val) =>
  //         String(val).toLowerCase().includes(searchText.toLowerCase())
  //       )
  //     );

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearFunction = () => {
    setSearchText("");
    setDropdownValue("");
    setStartDate(null);
    setEndDate(null);
    handleGetPrescribedList();
  };

  return (
    <Box>
      {loading && <MainLoader />}
      {/* header */}
      <AppBar
        position="static"
        sx={{ backgroundColor: "#3C4657", padding: "0 16px" }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            minHeight: "50",
          }}
          className="toolBarApp"
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <IconButton edge="start" color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton> */}
            <SidebarComp />
            <Typography
              className="siteHeading"
              variant="h6"
              sx={{ lineHeight: "0px" }}
            >
              Alopexia Prescribe
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }} className="">
            {/* <div className="reloadIcon" onClick={() => handleReloadData()}>
              <CachedIcon /> Sync
            </div> */}
            <div className="reportActionButton">
              <Button
                // variant="outlined"
                sx={{ color: "white", marginRight: 2 }}
                className="pendingButton"
              >
                <AssignmentTurnedInOutlinedIcon color="action" />{" "}
                <span>Prescribed</span>:
                <span className="commonBadge submittedIconColor">
                  {prescriptionCount?.validated_count ?? 0}
                </span>
              </Button>
              <Button
                // variant="outlined"
                sx={{ color: "white", marginRight: 2 }}
                className="pendingButton"
              >
                <img src={imgUrl.rejectIcon}></img> &nbsp;{" "}
                <span>Proscribed</span>:
                <span className="commonBadge pendingIconColor">
                  {prescriptionCount?.invalidated_count ?? 0}
                </span>
              </Button>

              <Button
                // variant="outlined"
                sx={{ color: "white", marginRight: 2 }}
                className="pendingButton"
              >
                <PendingActionsIcon color="action" /> <span>Pending</span>:
                <span className="commonBadge OpenIconColor">
                  {prescriptionCount?.pending_cases ?? 0}
                </span>
              </Button>
            </div>

            <Box
              display="flex"
              justifyContent="start"
              alignItems="center"
              flexDirection="column"
            >
              <IconButton
                color="inherit"
                // onClick={handleMenuOpen}
                sx={{ display: "flex", alignItems: "center", pr: 0 }}
              >
                <img src={imgUrl.DocProfile} alt="profile" />
                <span className="profileText">
                  &nbsp;
                  {loggedInDoctorInfo?.role == "doctor" ? "Dr." : ""}{" "}
                  {loggedInDoctorInfo?.full_name ?? "NA"}
                </span>
                {/* <ArrowDropDownIcon /> */}
              </IconButton>

              {/* <Select
                label="Profile Options"
                className="mainDropdown"
                value={selectedValue}
                onChange={handleChange}
                open={open}
                onClose={handleMenuClose}
                MenuProps={{
                  anchorEl: anchorEl,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                }}
              >
                <MenuItem value="logout" onClick={handleLogout}>
                  Logout
                </MenuItem>
              </Select> */}
              {/* </FormControl> */}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <div className="mainContainerSection">
        {/* main content */}
        <Box className="mainBoxSection">
          <div className="searchFilterWrapper">
            <TextField
              placeholder="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              fullWidth
              margin="normal"
              className="mainSearchBar"
            />
            {/* {console.log(dropdownValue, "::>>dropdownValue>>")} */}
            <Box sx={{ minWidth: 200 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={dropdownValue}
                  label="Select Status"
                  onChange={handleSelectFilter}
                  className="filterMenuItem"
                >
                  <MenuItem value="prescribed" className="filterMenuItem">
                    prescribed
                  </MenuItem>
                  <MenuItem value="proscribed" className="filterMenuItem">
                    proscribed
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <BasicDateRangePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              handleGetPrescribedList={handleGetPrescribedList}
            />
            <Button
              variant="contained"
              color="success"
              className="clearButton w-15"
              onClick={() => handleClearFunction()}
            >
              Clear
            </Button>
          </div>
          <Grid container spacing={2}>
            {/* box grid */}
            <Grid
              size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
              className="LeftGridSection"
            >
              <StyledCard sx={{ padding: 0 }} className="LeftBoxSection">
                {prescribedInfoList && prescribedInfoList.length > 0 && (
                  <BootstrapTable
                    className="prescribedInfoList"
                    keyField="id"
                    data={filteredPrescribedList}
                    columns={prescribedListColumn}
                    pagination={pagination}
                    bootstrap4
                    striped
                    hover
                    condensed
                  />
                )}
              </StyledCard>
            </Grid>
          </Grid>
        </Box>
      </div>

      {prescribedInfoList && prescribedInfoList.length == 0 && (
        <div className="mainContainerSection">
          <Box className="mainBoxSection">
            <div className="NoreportsText">Data Not Found</div>
          </Box>
        </div>
      )}

      {isUserIdle && (
        <Dialog
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            }
          }}
          open={isUserIdle}
          className="myCustomDialog"
          disableBackdropClick
        >
          <DialogTitle>
            You've been idle for a while. You'll be logged out in{" "}
            <strong>{formatSecondsToTime(secondsRemaining)}</strong>
          </DialogTitle>
          <div className="dialogButtonWrapper">
            <Button
              variant="contained"
              color="success"
              className="acceptButton pendingIconColor"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="acceptButton promptLogoutBtn"
              onClick={handleLogoutClick}
            >
              Logout
            </Button>
          </div>
        </Dialog>
      )}
    </Box>
  );
};

export default AllPrescribedData;
